import React, { useCallback, useEffect, useState } from "react";
import { mapTableRows } from "../../../../../utils";
import { employeePaymentDetailsrowData } from "../../../../../assets/data/candidatesData";
import {
  Button,
  InfoCardNewAdv,
  InfoTimeCardAdv,
  NewTable,
  PageHeader,
  PageTitle,
} from "../../../../../components";
import ReceivePayments from "./Deduction/Modals/ReceivePayments";
import { getTimesheetOneStart } from "../../../../../redux/slices/timesheets/timsheetSlice";
import { getCurrentInvoiceStart } from "../../../../../redux/slices/invoices/invoicesSlice";
import InvoiceDetails from "../../../Invoices/Invoices/InvoiceDetails";
import { useDispatch, useSelector } from "react-redux";
import common from "../../../../../utils/common";
import { fetchTimesheetsPlacements } from "../../../../../redux/slices/timesheets/timesheetApi";
import { getAllEmpDeductions } from "../../../../../redux/slices/payroll/payrollSlice";
import { fetchEmpDeduction } from "../../../../../redux/slices/payroll/payrollApi";
import { usePagination } from "../../../../../hooks";
import { formatCurrency } from "../../../../../utils/stringUtils";
import axiosRequest from "../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../redux/apiConfig";
import dayjs, { utc } from "dayjs";
import { exactUTCDate } from "../../../../../utils/dateFormator";
import {
  getINRPayRate,
  getUSPayRate,
} from "../../../../../utils/wf/placements.logic";
const UnpaidTimesheet = ({ setActiveTab }) => {
  const { getCutoffEndDateWithDayjs, convertLocalFormatMMDDYYYY } = common;
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
    error,
    employees,
  } = useSelector((state) => state.employee);
  const dispatch = useDispatch();
  const [unPaidTimeSheet, setUnPaidTimeSheet] = useState([]);
  const [empDeductions, setEmpDeductions] = useState([]);
  const [receivePayment, setReceicePayent] = useState(false);
  const [selectTimeSheet, setSelectTimeSheet] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPendingKPI, setTotalPendingKPI] = useState(0);
  const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClickInvoiceNumber = (row, invoiceNumToOpen) => {
    setSelectedInvoice(row);
    setShowInvoiceDetails(true);
    if (invoiceNumToOpen) {
      dispatch(
        getCurrentInvoiceStart({
          filters: { invoiceNum: { type: "NONE", value: invoiceNumToOpen } },
          coll: "Invoice",
          ref: "Client Employee Placement Timesheet",
          incl: ["", "firstName lastName", "", "attachments"],
        }),
      );
    }
  };

  const EmployepaymentdetailsColumns = [
    {
      key: "client",
      label: "Client",
      render: (row) => {
        return <di>{row?.clientId?.businessName}</di>;
      },
    },
    {
      key: "jobTitle",
      label: "Job Title",
      render: (row) => {
        return <di>{row?.placementId?.jobInfo?.jobTitle}</di>;
      },
    },
    {
      key: "payCycle",
      label: "Pay Cycle",
      render: (row) => {
        const fromDate = exactUTCDate(row?.period?.from);
        const toDate = exactUTCDate(row?.period?.to);
        return <div>{`${fromDate} - ${toDate}`}</div>;
      },
    },
    {
      key: "TotalHours",
      label: "Total Hours",
      render: (row) => {
        const totalHours = row?.dailyEntries
          ?.reduce((acc, curr) => acc + curr.st, 0)
          .toFixed(2);
        return <div>{totalHours}</div>;
      },
    },
    {
      key: "invoiceNumbers",
      label: "Invoice Numbers",
      render: (row) => (
        <div className="flex items-center gap-3 group">
          <div className="flex gap-2 items-center flex-wrap">
            {row?.invoiceId?.map((idObj, index) => {
              const invNum = idObj?.invoiceNum;
              if (!invNum) return null;

              return (
                <span key={index} className="flex">
                  <span
                    className={`cursor-pointer hover:underline ${
                      row?.qbSync?.id
                        ? "text-success"
                        : row?.qbSync?.error
                          ? "text-danger"
                          : "text-linkblue"
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleClickInvoiceNumber(row, invNum);
                    }}
                  >
                    {invNum}
                  </span>
                  {index < row.invoiceId.length - 1 && <span>,</span>}
                </span>
              );
            })}
          </div>
        </div>
      ),
    },
    {
      key: "usPayRate",
      label: "US Pay Rate",
      render: (row) => getUSPayRate(row?.placementId?.payments),
    },
    {
      key: "indiaPayRate",
      label: "India Pay Rate",
      render: (row) => getINRPayRate(row?.placementId?.payments),
    },
    {
      key: "totalAmount",
      label: "Total Amount",
      render: (row) => {
        return <div>{formatCurrency(row?.amounts?.total)}</div>;
      },
    },
    {
      key: "balancedAmount",
      label: "Balanced Amount",
      render: (row) => {
        const balance = row.amounts.total - row.amounts.paid || 0;
        return <div>{formatCurrency(balance)}</div>;
      },
    },
  ];
  const { page, limit, setPage, handleLimitChange } = usePagination(10);
  const mappedRows = mapTableRows(
    unPaidTimeSheet,
    EmployepaymentdetailsColumns,
  );

  const handleCallTimeSheet = useCallback(async () => {
    if (!employeeProfileUiid) return;
    const payload = {
      limit,
      page,
      filters: {
        employeeId: {
          type: "NONE",
          value: employeeProfileUiid,
        },
        status: {
          type: "NONE",
          value: 6,
        },
        paid: {
          type: "NONE",
          value: false,
        },
        "period.to": {
          type: "LTE",
          value: getCutoffEndDateWithDayjs().toISOString(),
        },
      },
      sort: {
        "period.to": -1,
      },
      ref: "Client Placement Invoice",
      incl: ["businessName", "jobInfo.jobTitle payments", "invoiceNum"],
    };
    const payloaddata = {
      coll: "EmpDeduction",
      filters: {
        type: { type: "NONE", value: 1 },
        stop: { type: "NONE", value: false },
        employeeId: { type: "NONE", value: employeeProfileUiid },
      },
    };

    try {
      setLoading(true)
      const timesheetResponse = await fetchTimesheetsPlacements(payload);
      const timesheetData = timesheetResponse?.data?.data || [];
      const total = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.TIMESHEETS.GET_TOTAL_COUNT,
        params: {
          coll: "Timesheet",
          fil: JSON.stringify(payload.filters),
          sort: JSON.stringify({
            "period.from": -1,
          }),
        },
      });
      const totalPendingKPI = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.TIMESHEETS.GET_ALL,
        params: {
          useAggregate: true,
          coll: "Timesheet",
          fil: JSON.stringify({
            unpaidTS: {
              type: "AG_STATS",
              value: [
                employeeProfileUiid,
                false,
                dayjs(getCutoffEndDateWithDayjs().toISOString())
                  .utc()
                  .format("YYYY-MM-DD"),
                6,
              ],
            },
          }),
        },
      });
      setTotalPendingKPI(totalPendingKPI?.data?.data?.[0]?.pendingTotal || 0);
      setTotalCount(total?.data?.data || 0);
      setUnPaidTimeSheet(timesheetData);
    } catch (err) {
      console.error("Unpaid TS", err);
      setUnPaidTimeSheet([]); // Optional: clear on error
    }finally{
      setLoading(false)
    }

    try {
      const deductionResponse = await fetchEmpDeduction(payloaddata);
      const deductionData = deductionResponse?.data?.data || [];
      setEmpDeductions(deductionData);
    } catch (err) {
      setEmpDeductions([]); // Optional: clear on error
    }
  }, [employeeProfileUiid, limit, page]);

  useEffect(() => {
    handleCallTimeSheet();
  }, [page, limit, employeeProfileUiid]);

  const handleSelectTime = (row) => {
    const filterData = unPaidTimeSheet.filter((data) => row.includes(data._id));
    setSelectTimeSheet(filterData);
  };
  return (
    <div className="border-[1px] border-neutrals-50 rounded p-3 mt-3 flex-1 flex flex-col overflow-hidden">
      {showInvoiceDetails ? (
        <InvoiceDetails
          onBack={() => {
            setShowInvoiceDetails(false);
            setSelectedInvoice(null);
          }}
          invoiceData={selectedInvoice}
        />
      ) : (
        <>
          <div className="flex justify-end mb-2">
            <InfoCardNewAdv
              title={"Total Pending Amount"}
              value={formatCurrency(totalPendingKPI || 0)}
              layout="option13"
              isLoading={loading}
            />
          </div>
          <div className="flex-1 flex overflow-hidden">
            <NewTable
              columns={EmployepaymentdetailsColumns}
              rows={mappedRows}
              // hideToolBar
              showCheckbox
              serverPagination={true}
              totalCount={totalCount || 100}
              // totalCount={100}
              page={page}
              limit={limit}
              onPageChange={setPage}
              onLimitChange={handleLimitChange}
              defaultSelectedRows={selectTimeSheet.map((data) => data._id)}
              onSelectionChange={(row) => {
                handleSelectTime(row);
              }}
            />
          </div>

          <div className="mt-6 flex justify-end gap-2 ">
            <Button title="Cancel" variant="outlined" onClick={() => {}} />
            <Button title="Submit" onClick={() => setReceicePayent(true)} />
          </div>
        </>
      )}
      {receivePayment && (
        <ReceivePayments
          isOpen={receivePayment}
          onClose={() => setReceicePayent(false)}
          setActiveTab={setActiveTab}
          shouldMoveTab={false}
          unpaidTime={true}
          empDeductions={empDeductions}
          selectTimeSheet={selectTimeSheet}
          callFunction={handleCallTimeSheet}
        />
      )}
    </div>
  );
};

export default UnpaidTimesheet;
